.integrationRow {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 12px;
    border: 1px solid var(--mui-palette-divider, #e0e0e0);
    border-radius: 8px;
}

.integrationRowHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 8px;
}

.integrationFieldsGrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
    row-gap: 8px;
}

@media (max-width: 768px) {
    .integrationFieldsGrid {
        grid-template-columns: 1fr;
    }
}
